import store from "@/state/store";

function getStore(st, num){
  if (st.getters["auth/loggedIn"]) { next({ name: "default" }) } else { next()} //next
}

function getStoreAdmin(st, num){
  if (st.getters["authfack/loggedInAdmin"]) { next(); // next ad
  } else { 
    next({ name: "Error-404" })
  }
}

export default [
  {
    path: "/",
    name: "default",
    meta: {
      authRequired: true,
    },
    //component: () => import("./views/dashboards/default"),
    component: () => import("./views/dashboards/manager/producto"),

  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in login
        getStore(store, 1) // 1
      },
    },
  },
  {
    path: "/error",
    name: "error",
    component: () => import("./views/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in login
        getStore(store, 1) // 1
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("./views/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in register
        getStore(store, 2) // 2
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("./views/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in forgot-password
        getStore(store, 3) // 3
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch("authfack/logout");
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login")
        );
        // Navigate back to previous page, or home as a fallback
        next(
          authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom }
        );
      },
    },
  },
  {
    path: "/cotizador",
    name: "cotizador",
    meta: { authRequired: true,  }, component: () => import("./views/dashboards/cotizador")
  },
  {
    path: "/exportarpdf",
    name: "exportarpdf",
    meta: { authRequired: true },
    component: () => import("./views/dashboards/exportarpdf"),
  },
  {
    path: "/404",
    name: "404",
    component: require("./views/utility/404").default },
  {
    path: "*",
    redirect: "404"},
  {
    name: "cotizador-history",
    path: "/cotizador-history",
    meta: { authRequired: true, test: 6 }, component: () => import("./views/dashboards/cotizador-history")},
  {
    name: "session-history",
    path: "/session-history",
    meta: { authRequired: true, test: 5 }, component: () => import("./views/dashboards/session-history")},
  {
    path: "/cotizador-detail/:id",
    name: "cotizador-detail",
    meta: { authRequired: true, test: 1 }, component: () => import("./views/dashboards/cotizador-detail")},
  {
    path: "/clients-detail/:id",
    name: "clients-detail",
    meta: { authRequired: true, test: 2 }, component: () => import("./views/dashboards/clients/clients-detail")},
  {
    path: "/clients-list",
    name: "clients-list",
    meta: { authRequired: true, test: 3 }, component: () => import("./views/dashboards/clients/clients-list")},
  {
    path: "/profile/change-password",
    name: "change-password",
    meta: { authRequired: true, test: 4 }, component: () => import("./views/account/change-password")},
  {
    path: "/manager/costos",
    name: "costos",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 10) // 10
      },
    },
    component: () => import("./views/dashboards/manager/costos")},
  {
    path: "/manager/costos-referencia",
    name: "costos-referencia",
    meta: { authRequired: true, test: 7,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 11) // 11
      },
    },
    component: () => import("./views/dashboards/manager/costos-referencia")},
  {
    path: "/manager/centro-referencia",
    name: "centro-referencia",
    meta: { authRequired: true, test: 8,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 12) // 12
      },
    },
    component: () => import("./views/dashboards/manager/centro-referencia")},
  {
    path: "/manager/centro-referencia-list",
    name: "centro-referencia-list",
    meta: { authRequired: true, test: 9,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 13) // 13
      },
    },
    component: () => import("./views/dashboards/manager/centro-referencia-list")},
  {
    path: "/manager/centro-de-costos",
    name: "centro-de-costos",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 14) // 14
      },
    },
    component: () => import("./views/dashboards/manager/centro-de-costos")},
  {
    path: "/manager/usuarios",
    name: "usuarios",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 15) // 15
      },
    },
    component: () => import("./views/dashboards/usuarios")},
  {
    path: "/manager/imagenes",
    name: "imagenes",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 15) // 15
      },
    },
    component: () => import("./views/dashboards/manager/images")},
  {
    path: "/manager/clients",
    name: "clients",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 15) // 15
      },
    },
    component: () => import("./views/dashboards/manager/clients")},
  {
    path: "/manager/clases-de-actividad",
    name: "clases-de-actividad",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 16) // 16
      },
    },
    component: () => import("./views/dashboards/manager/clases-de-actividad"),
  },
  {
    path: "/manager/material",
    name: "material",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 17) // 17
      },
    },
    component: () => import("./views/dashboards/manager/material"),
  },
  {
    path: "/manager/puesto-de-trabajo",
    name: "puesto-de-trabajo",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 18) // 18
      },
    },
    component: () => import("./views/dashboards/manager/puesto-de-trabajo"),
  },
  {
    path: "/manager/producto",
    name: "producto",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 19) // 19
      },
    },
    component: () => import("./views/dashboards/manager/producto"),
  },
  {
    path: "/manager/producto/:id",
    name: "producto-detail",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 20) // 20
      },
    },
    component: () => import("./views/dashboards/manager/producto-detail"),
  },
  {
    path: "/manager/producto-add",
    name: "producto-add",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 21) // 21
      },
    },
    component: () => import("./views/dashboards/manager/producto-add"),
  },
  {
    path: "/manager/variable/trm",
    name: "variable-trm",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 22) // 22
      },
    },
    component: () => import("./views/dashboards/manager/variable-trm"),
  },
  {
    path: "/manager/variable/cycles",
    name: "variable-cycles",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 23) // 23
      },
    },
    component: () => import("./views/dashboards/manager/variable-cycle"),
  },
  {
    path: "/manager/variable/grafado",
    name: "variable-grafado",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 24) // 24
      },
    },
    component: () => import("./views/dashboards/manager/variable-grafado"),
  },
  {
    path: "/manager/variable/inyeccion",
    name: "variable-inyeccion",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 25) // 25
      },
    },
    component: () => import("./views/dashboards/manager/variable-inyeccion"),
  },
  {
    path: "/manager/variable/empaque",
    name: "variable-empaque",
    meta: { authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        getStoreAdmin(store, 26) // 26
      },
    },
    component: () => import("./views/dashboards/manager/variable-empaque"),
  },
  {
    path: "/manager/categories",
    name: "categories",
    meta: { authRequired: true, beforeResolve(routeTo, routeFrom, next) { getStoreAdmin(store, 27) },
    }, component: () => import("./views/dashboards/manager/categories"),
  },
  {
    path: "/pages/pricing",
    name: "Pricing",
    meta: { authRequired: true }, component: () => import("./views/utility/pricing"),
  },
  {
    path: "/pages/404",
    name: "Error-404",
    meta: { authRequired: true }, component: () => import("./views/utility/404"),
  },
  {
    path: "/pages/500",
    name: "Error-500",
    meta: { authRequired: true }, component: () => import("./views/utility/500"),
  },
];